export default __webpack_public_path__ + "static/home-house-ad4c0e67689ea76fa6f5fad30dd1377c.jpg";